import React, { useState} from "react";
// node.js library that concatenates classes (strings)
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import HeaderEmpty from "components/Headers/HeaderEmpty";
//import DaySelfSales from "./DaySelfSales";
import DaySelfSales from "views/seller/DaySelfSales";
import AuthFooter from 'components/Footers/AuthFooter'
//import TopSeller from "./TopSeller";
import TopSeller from "views/seller/TopSeller";
//import DepositToShop from "./DepositToShop";
import DepositToShop from "views/seller/DepositToShop";
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import {openDoorAPI} from 'network/ApiAxios'
import MoneySellers from "views/shop/MoneySellers";
import EditOrders from "views/examples/ticketing/EditOrders";
import DaySalesBySeller from "./DaySalesBySeller";

const Index = (props) => {
    const [camera, setcamera] = useState(false)
    const [doorOpen, setDoorOpen] = useState('primary');
  
    const scanQR = ()=>{
      setcamera(!camera)
    }

    const openDoor = async()=>{
        const resAxios = await openDoorAPI()
        if(resAxios.data.success){
          setDoorOpen('action')
        }else{
          setDoorOpen('error')
        }
      }

    return (
      <>
      <HeaderEmpty />  
        {/* Page content */}
        <Container fluid>
         
          <Row  >
            <Col className="mb-5 mt-8 mb--7 mb-xl-0" xl="8">
              <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      <h2 className="text-white">Day Sales</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <DaySelfSales/>
                </CardBody>
              </Card>
            </Col>
            <Col xl="4" className="mt-8">
              <Card className="shadow">
                <CardHeader className="bg-transparent">
                  <Row>
                    <div className="d-flex" style={{alignItems: "center"}}>
                      <h2 className="mb-0 mr-5">Today Top Seller</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                   <TopSeller/>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="8">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Door Access
                        </CardTitle>
                        <Button onClick={openDoor} ><MeetingRoomIcon color={doorOpen} />Open Door</Button>
                      </div>
                  </Row>
                </CardHeader>
                
              </Card>
            </Col>
            <Col xl="4">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Money to Deposit</h3>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <DepositToShop/>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="8">
              <Card className="bg-gradient-default shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Money with Sellers
                        </CardTitle>
                      </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <MoneySellers/>
                </CardBody>
                
              </Card>
            </Col>
            <Col xl="4">
              <Card className="bg-gradient-default shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Something </h3>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
              <Card className="bg-gradient-default shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Orders not Collected Past 7 days </h3>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <EditOrders/>
                </CardBody>
              </Card>
          </Row>
          <Row  >
            <Col className="mb-5 mt-8 mb--7 mb-xl-0" xl="8">
              <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      <h2 className="text-white">Day Ticket Sales</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <DaySalesBySeller/>
                </CardBody>
              </Card>
            </Col>
          </Row>
          
        </Container>
        <AuthFooter/>
      </>
    );
  
}

export default Index;
